export class AppError extends Error {
  constructor(
    message: string,
    public i18nKey?: string
  ) {
    super(message);
  }
}
